import { ImageAsset } from '@common/model/resource/image';
import { isNextImage, nextToAsset } from './nextImage';
import { toAssetItem } from './assetItem';

const isAsset = (source: unknown): source is ImageAsset => typeof source === 'object' && source !== null && source.hasOwnProperty('base');

/**
 * Coerce images in some formats to ImageAsset format
 * @param source
 */
export const toAsset = (source: unknown): ImageAsset => {
  if (typeof source === 'string') {
    return { base: toAssetItem(source) };
  }
  if (isNextImage(source)) {
    return nextToAsset(source);
  }
  if (isAsset(source)) {
    return source;
  }
  return { base: toAssetItem(source) };
};

export const withWebp = (asset: ImageAsset) => (source: unknown) => {
  asset.webp = toAsset(source).base;
  return asset;
};
